import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
Vue.use(VueRouter)

// Uncaught (in promise) Error: Navigation cancelled
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Links',
    component: () => import('../views/Links.vue')
  },
  {
    path: '/console',
    name: 'Console',
    component: () => import('../views/Console.vue')
  },
  {
    path: '/details/:docid',
    name: 'Details',
    component: () => import('../views/Details.vue')
  },
  {
    path: '/post',
    name: 'Post',
    component: () => import('../views/cms/Post.vue')
  },
  {
    path: '/genarate',
    name: 'Genarate',
    component: () => import('../views/cms/Genarate.vue')
  },
  {
    path: '/postGeneral',
    name: 'PostGeneral',
    component: () => import('../views/cms/PostGeneral.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/account/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/account/Register.vue')
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: () => import('../views/account/Recovery.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/account/Profile.vue')
  },
  {
    path: '/passwordChange',
    name: 'PasswordChange',
    component: () => import('../views/account/PasswordChange.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.info(to)

  // redirect to login page if not logged in and trying to access a restricted page
  const noSecurePages = ['Recovery', 'Login', 'Register', 'Links', 'Details', 'Links']
  const authRequired = !noSecurePages.includes(to.name)
  var authenticated = localStorage.getItem('authenticated') || "false"
  if (authRequired && authenticated == "false") {
    store.state.redirectPage = to.name
    return next('/login')
  }
  next()
})

export default router
